<template>
<div class="container-fluid" :class="{'bg-default-color' : !backgroundWhite, 'bg-white': backgroundWhite}">

	<toolbar>
		<router-link v-if="activeTab == 'dashboard' || $route.params.id == 'new'" to="/projects/list" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>Projects</h2>
		</router-link>
		<router-link v-else :to="'/project/'+$store.project.slug+'/dashboard'" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>Dashboard</h2>
		</router-link>

		<div class="controls">
			<template v-if="extraActionMenuItemsStart.length == 0">
				<button class="btn btn-primary" v-on:click="doCompanyForm" :disabled="!$store.project || !('id' in $store.project)">
					<i class="fa fa-fw fa-clipboard-check"></i>
					Do Company Form
				</button>

				<button class="btn btn-success" v-on:click="newMessage">
					<i class="fa fa-plus"></i>
					<i class="fa fa-envelope"></i>
				</button>
			</template>

			<nav-tabs v-if="$route.params.id != 'new'"
				:tabs="filteredTabs" 
				:active-index="activeTabIndex" 
				:extra-action-menu-items-start="extraActionMenuItemsStart"
				:more-heading="morePanelHeading"
				:mobile-breakpoint="mobileBreakpoint"
				addon-apps-location="Project Record"
				:addon-apps-link=" '/project/'+$store.project.slug+'/apps'"
				v-on:tabClick="navTabClick"
				v-on:buttonClick="navTabActionsItemClick">
			</nav-tabs>
		</div>
	</toolbar>

	<template v-if="$store.project">
		<job-delete-alert v-if="$store.project.deleted == 1" job-api-resource="Job"></job-delete-alert>
		<div v-else-if="$store.project.archived == 1" class="alert alert-warning job-status-alert">
			<i class="fa fa-archive"></i>
			This project is archived. In order to make changes you need to un-archive it.
		</div>
		<div v-else-if="$store.project.date_completed" class="alert alert-success job-status-alert">
			<i class="fa fa-check-square"></i>
			This project was completed on {{$store.project.date_completed}}.
		</div>
	</template>

	<template v-if="showTitleWidget">
		<heading-widget v-if="$route.params.id == 'new'"
			title="New Project">
		</heading-widget>

		<heading-widget v-else
			:title="$store.project.job_num+': '+$store.project.job_name"
			:small="projectHeadingSmall">

			<div>
				<div class="w-100 text-right">
					<button v-if="!$store.clockedIn && $store.project.archived != 1 && !$store.project.date_completed"
							  class="btn btn-success"
							  v-on:click="clockInToProject">
						<i class="fa fa-clock"></i>
						Clock In to Project
					</button>
				</div>

				<div v-if="$store.project.UpdatedBy" class="text-muted">
					<hr>
					Last edited by {{ $store.project.UpdatedBy.first_name }} {{ $store.project.UpdatedBy.last_name }} @ {{ formatDateTimeToLocal($store.project.updated_at) }}
				</div>
			</div>
		</heading-widget>
	</template>

	<project-dashboard v-if="activeTab == 'dashboard'" 
		:key="$route.params.id">
	</project-dashboard>

	<project-details v-else-if="activeTab == 'details'" 
		:section="activeDetailsSection"
		v-on:fetchProject="fetchData" 
		:key="$route.params.id">
	</project-details>

	<!--
	<project-estimate v-else-if="activeTab == 'estimate'" 
		v-on:fetchJob="fetchData"
		:key="$route.params.id">		
	</project-estimate>
	-->

	<project-bidding v-else-if="activeTab == 'bidding'">
	</project-bidding>

	<project-tasks-draw v-else-if="activeTab == 'tasks-draw'"
		 :key="$route.params.id"> 	
	</project-tasks-draw>

	<project-hours v-else-if="activeTab == 'hours'"
		 :key="$route.params.id">	
	</project-hours>

	<expense-table v-else-if="activeTab == 'expenses' && $store.project.id"
		heading="Expenses"
		:heading-small="'Project #'+$store.project.job_num+', '+$store.project.job_name"
		:show-user="true"
		:show-job="false"
		:editable="true"
		:filtering-tools="true"
		:filters='[
			["job_id",this.$store.project.id]
		]'>
	</expense-table>

	<job-messages v-else-if="activeTab == 'messages'" 
		:key="$route.params.id">	
	</job-messages>

	<job-files v-else-if="activeTab == 'files'" 
		:key="$route.params.id"
		parent-resource="Job"
		parent-record-slug-route-param-key="id"
		store-location="project">	
	</job-files>

	<project-reports v-else-if="activeTab == 'reports'"
		:key="$route.params.id">
	</project-reports>

	<purchase-orders v-else-if="activeTab == 'purchase-orders'"
		:key="$route.params.id">	
	</purchase-orders>

	<project-quoting v-else-if="activeTab == 'change-quotes'" 
		:key="$route.params.id">	
	</project-quoting>

	<project-billing v-else-if="activeTab == 'billing'"
		:key="$route.params.id">	
	</project-billing>

	<project-material-list v-else-if="activeTab == 'material-list'" 
		:key="$route.params.id">	
	</project-material-list>

	<project-notes v-else-if="activeTab == 'notes'"
		:key="$route.params.id">		
	</project-notes>

	<forms-tab v-else-if="activeTab == 'forms'"
		:customer-id="'customer_id' in $store.project ? $store.project.customer_id : false"
		:project-id="'id' in $store.project ? $store.project.id : false">
	</forms-tab>

	<locates v-else-if="activeTab == 'locates'"
		:key="$route.params.id"
		:job-id="$store.project.id"
		:has-job-id="true">		
	</locates>

	<services-list-widget v-else-if="activeTab == 'services'"
		:show-total-labour-hours="true"
		title="Services attached to this Project"
		v-on:fetchServices="fetchServices">
	</services-list-widget>

	<schedule-component v-else-if="activeTab == 'schedule'"
		:project-id="$store.project.id">
	</schedule-component>

	<addon-app-tab v-else-if="activeTab == 'apps'" ui-location="Project Record"></addon-app-tab>

</div>
</template>

<script>
import ProjectDashboard from "./project/project_tabs/ProjectDashboard"
import ProjectDetails from "./project/project_tabs/ProjectDetails"

import HeadingWidget from '../components/HeadingWidget'
import ModalDialog from "@/components/ModalDialog"

import ProjectTasksDraw from "./project/project_tabs/ProjectTasksDraw"
import ProjectHours from "./project/project_tabs/ProjectHours"
import JobMessages from "./project/JobMessages"
//import ProjectEstimate from "./project/project_tabs/ProjectEstimate"
import ProjectBidding from "./project/project_tabs/bidding/ProjectBidding"
import ProjectReports from "./project/project_tabs/ProjectReports"
import PurchaseOrders from "./project/PurchaseOrders"
import ProjectNotes from "./project/project_tabs/ProjectNotes"
import ProjectBilling from "./project/project_tabs/ProjectBilling"
import ProjectQuoting from "./project/project_tabs/ProjectQuoting"
import JobFiles from "@/pages/project/JobFiles"
import Locates from "@/pages/Locates"
import AddonAppTab from "@/components/AddonAppTab"
import FormsTab from "@/components/super_components/FormsTab"
import ServicesListWidget from "@/components/super_components/ServicesListWidget"
import JobDeleteAlert from "@/components/super_components/JobDeleteAlert"
import ScheduleComponent from "@/components/schedule/ScheduleComponent"

import ExpenseTable from "@/components/super_components/ExpenseTable"

import NavTabs from "../layout_fragments/NavTabs"
import Toolbar from "../layout_fragments/Toolbar"
import TableList from "../components/TableList"
import FormGroup from "../components/FormGroup"
import Field from "../components/Field"

import JobMixins from "@/mixins/JobMixins.js"

export default {

	name: 'Project',
	components: {
		Toolbar,
		TableList,
		FormGroup,
		Field,
		NavTabs,
		ProjectDashboard,
		ProjectDetails,
		ProjectTasksDraw,
		ProjectHours,
		ExpenseTable,
		//ProjectEstimate,
		ProjectBidding,
		ProjectReports,
		PurchaseOrders,
		ProjectNotes,
		ProjectQuoting,
		ProjectBilling,
		JobFiles,
		JobMessages,
		HeadingWidget,
		ModalDialog,
		Locates,
		AddonAppTab,
		FormsTab,
		ServicesListWidget,
		JobDeleteAlert,
		ScheduleComponent
	},
	mixins: [JobMixins],
	data() {
		return {
			activeTab: this.$route.params.tab,
			activeDetailsSection: null,
			mobileBreakpoint: 1024,
		}
	},
	//remove project data from $store when we navigate away
	beforeRouteLeave(to,from,next) {
		this.$store.project = {}

		next()
	},
	computed: {
		scheduleFilters() {
			let vm = this

			if ("ScheduleEvent" in this.$store.project && this.$store.project.ScheduleEvent.length > 0) {
				return {
					mainTypes: ["project","user"],
					projectIds: [this.$store.project.id],
					serviceIds: [],
					equipmentIds: [],
					userIds: [],
					showOnlyRelated: true
				}
			}
			else
				return false
		},
		backgroundWhite() {
			let tabsWithGray = [
				"dashboard",
				"details",
				"notes"
			]

			return !tabsWithGray.find(tab => this.activeTab == tab)
		},
		extraActionMenuItemsStart() {
			let items = []
			if (window.innerWidth < this.mobileBreakpoint) {

				let disabled = !("id" in this.$store.project) || !this.$store.project.id

				items.push({label: "Do Company Form",icon:"fa-clipboard-check",click:"doCompanyForm",disabled})
				
				items.push({
					label: "Message Thread",
					icon: "fa-plus",
					click: "newMessage",
					disabled
				})
			}
			return items
		},
		activeTabIndex() {
			let vm = this

			let isMore = false
			let index = this.filteredTabs.findIndex(tab => {
				if ("click" in tab) {
					let segs = tab.click.split("/")

					if (segs[3] == vm.activeTab) 
						return true
					
				}
			})

			return index

		},
		morePanelHeading() {
			if (this.$store.project)
				return "Project #"+this.$store.project.job_num

			return ""
		},
		tabs() {

			if (!this.$store.project || (this.$store.project && !("slug" in this.$store.project)))
				return []

			let tabs = [
					{
						label: "Dashboard",
						path: "/project/"+this.$route.params.id+"/dashboard",
						icon: "fa-tachometer-alt",
						bidTab: true
					},
					{
						label: "Messages",
						path: "/project/"+this.$route.params.id+"/messages",
						icon: "fa-envelope",
						bidTab: true
					},
					{
						label: "Time Logs",
						path: "/project/"+this.$route.params.id+"/hours",
						icon: "fa-clock",
						bidTab: true
					},
					{
						label: "Expenses",
						path: "/project/"+this.$route.params.id+"/expenses",
						icon: "fa-receipt",
						bidTab: true
					}
				]

			//User is not Admin, doesn't have Job read perms, and has no role on project. Can see Dashboard only
			if (!("User" in this.$store.project) || !this.$store.project.User || (!this.$store.project.User.find(user => user.id == this.$store.userDetails.id) && this.getUserRoleType() != 'Admin' && !this.hasModulePermRead("Jobs"))) 
				return tabs
			
			let numFiles = ""
			if ("JobFile" in this.$store.project && this.$store.project.JobFile && this.$store.project.JobFile.length > 0)
				numFiles = " ("+this.$store.project.JobFile.length+")"

			tabs = [
				{
					label: "Dashboard",
					path: "/project/"+this.$route.params.id+"/dashboard",
					icon: "fa-tachometer-alt",
					bidTab: true
				},
				{
					label: "Details",
					path: "/project/"+this.$route.params.id+"/details",
					icon: "fa-list",
					bidTab: true
				},
				{
					label: "Bid",
					path: "/project/"+this.$route.params.id+"/bidding",
					icon: "fa-pencil-ruler",
					bidTab: true
				},
				{
					label: "Forms",
					path: "/project/"+this.$route.params.id+"/forms",
					icon: "fa-clipboard-check",
				},
				{
					label: "Files"+numFiles,
					path: "/project/"+this.$route.params.id+"/files",
					icon: "fa-file-image",
					bidTab: true
				},
				{
					label: "Messages",
					path: "/project/"+this.$route.params.id+"/messages",
					icon: "fa-envelope",
					more: true,
					bidTab: true
				},
				{
					label: "Services",
					path: "/project/"+this.$route.params.id+"/services",
					icon: "fa-wrench",
					more: true
				},
				{
					label: "Locates",
					path: "/project/"+this.$route.params.id+"/locates",
					icon: "fa-map-pin",
					more: true
				},
				{
					label: "Time Logs",
					path: "/project/"+this.$route.params.id+"/hours",
					icon: "fa-clock",
					more: true,
					bidTab: true
				},
				{
					label: "Expenses",
					path: "/project/"+this.$route.params.id+"/expenses",
					icon: "fa-receipt",
					more: true,
					bidTab: true
				},
				/* DEPRECATED/REMOVED
				{ 
					label: "Estimate",
					path: "/project/"+this.$route.params.id+"/estimate/summary",
					icon: "fa-pencil-ruler",
					more: true,
					bidTab: true
				},
				*/
				{
					label: "Change Orders",
					path: "/project/"+this.$route.params.id+"/change-quotes",
					icon: "fa-file-invoice-dollar",
					more: true
				},
				{
					label: "Billing",
					path: "/project/"+this.$route.params.id+"/billing/schedule-of-values",
					icon: "fa-file-invoice-dollar",
					modulePermRequired: ["Job Invoices"],
					more: true
				},
				{
					label: "Purchase Orders",
					path: "/project/"+this.$route.params.id+"/purchase-orders",
					icon: "fa-file-invoice",
					modulePermRequired: ["Purchase Orders"],
					more: true
				},
				{
					label: "Schedule",
					path: "/project/"+this.$route.params.id+"/schedule",
					icon: "fa-calendar-alt",
					more: true
				},
				{
					label: "Reports",
					path: "/project/"+this.$route.params.id+"/reports/labour-progress",
					icon: "fa-chart-line",
					more: true,
					bidTab: true
				},
				{
					label: "Notes",
					path: "/project/"+this.$route.params.id+"/notes",
					icon: "fa-pencil-alt",
					more: true
				}
			]

			if (this.$store.project.is_lead == 1)
				return tabs.filter(tab => "bidTab" in tab && tab.bidTab)

			return tabs
		},
		showTitleWidget() {
			let include = [
				"dashboard"
			]

			if (include.indexOf(this.activeTab) >= 0){
				return true
			}
			else 
				return false
		},
		filteredTabs() {
			let vm = this
			return this.tabs.filter(tab => {

				let locatesPath = "/project/"+this.$route.params.id+"/locates"

				//show locates tab if has locates
				if (tab.path == locatesPath && vm.$store.project.has_locates == 0 && (!("Locate" in vm.$store.project) || !vm.$store.project.Locate || vm.$store.project.Locate.length == 0))
					return false

				if (tab.label == "Services") {
					if (!("Service" in this.$store.project) || !(this.$store.project.Service) || this.$store.project.Service.length == 0)
						return false
				}

				else
					return true
			})
		}
	},
	methods: {
		doCompanyForm() {
			this.$bus.$emit("doCompanyForm",{job_id: this.$store.project.id})
		},
		navTabClick(path) {
			this.$router.push(path)
		},
		navTabActionsItemClick(item) {
			if ("path" in item)
				this.$router.push(item.path)
			else if ("click" in item) 
				this[item.click]()
			else 
				this.actionsMenuOpen = false
		},
		newMessage() {
			this.$bus.$emit("newThread","project",this.$store.project.id)
		},
		restoreProject() {
			let vm = this

			this.postData("Job/save",{id:vm.$store.project.id,deleted:0}).then(response => {
				if (response.success)
					vm.$store.project.deleted = 0
			})
		},
		fetchServices(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let params = {
				filters: [
					["job_id",this.$store.project.id]
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("Service/get",params).then(response => {
					if (spinner)
						vm.spinner(false)

					resolve(response)
				})

			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)
			
			let promises = [
				this.getJSON("PayBoost/get"),
				this.fetchUnions(),
				this.fetchCompanyData(false,["CompanySetting","AddonApp","ProfileImage","JobBid"])
			]

			if (this.$route.params.id != "new" || "slug" in this.$store.project) {


				let slug
				if ("slug" in this.$store.project)
					slug = this.$store.project.slug
				else
					slug = this.$route.params.id

				promises.push(this.fetchProject(false,slug))

			}

			Promise.all(promises).then(function(responses){
				if (vm.activeTab == 'services')
					vm.fetchServices(true)
				else
					vm.spinner(false)

				vm.$store.payBoostOptions = vm.optionify(responses[0].data,"description")

				if (responses[1].success) 
					vm.bindDefaultCollectiveAgreements(responses[1].data)
			})
		}
	},
	created() {
		this.fetchData()
		this.activeTab = this.$route.params.tab

		if ("tag" in this.$route.params && this.$route.params.tag)
			this.activeDetailsSection = this.$route.params.tag

	}

}
</script>